jQuery(function($){
  $('.feature').on('click', function(e){
    e.stopPropagation();

    const targetId = $(this).data('target');

    $('.popup').removeClass('popup-opened');
    $('#' + targetId).addClass('popup-opened');
  });

  $(document).on('click', function(){
    $('.popup').removeClass('popup-opened');
  });

  $('.popup').on('click', function(e){
    e.stopPropagation();
  });

  $('.popup-close').on('click', function(){
    $('.popup').removeClass('popup-opened');
  });

  $('.feature').on('click', function () {
    var popupId = $(this).data('target');
    var questionNumber = popupId.split('-')[1];

    $.post(ajax_data.ajaxurl, {
      action: 'increment_question_count',
      question_id: questionNumber,
      post_id: ajax_data.post_id,
      lang: ajax_data.lang
    });
  });

  $('.begin-quiz').on('click', function (e) {
    e.preventDefault();

    var redirectUrl = $(this).data('url');

    $.post(ajax_data.ajaxurl, {
      action: 'increment_total_sessions',
      post_id: ajax_data.post_id,
      lang: ajax_data.lang
    }).always(function () {
      window.location.href = redirectUrl;
    });
  });

  if ($('body').hasClass('page-template-template-quiz')) {
    const redirectUrl = ajax_data.localized_home_url;
    const INACTIVITY_LIMIT = 20000;
    let inactivityTimeout;

    function resetInactivityTimer() {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(function () {
        window.location.href = redirectUrl;
      }, INACTIVITY_LIMIT);
    }

    ['mousemove', 'keydown', 'click', 'touchstart'].forEach(function(evt) {
      document.addEventListener(evt, resetInactivityTimer);
    });

    resetInactivityTimer();
  }
});
